import React, {useState, useCallback, useEffect} from 'react';
import {Alert, Select, Stack, Typography} from '@wellstone-solutions/web';

import {Api} from '@wellstone-solutions/common';
import PfModal from '../../modal/PfModal';
import {getRawDateRange, processRawData} from '../../../utils/Charts';
import {DateRangePicker} from 'react-date-range';
import {Palette} from '../../../palette';
import {aggregatingList} from '../../../constants/Aggregators';
import MembersOverview from '../../MembersOverview';
import moment from 'moment';
import {LoadingIndicator} from '../../shared/LoadingIndicator';
import {EventEmitter} from '../../../utils/EventEmitter';
const Activity = (props) => {
  const [aggregator, setAggregator] = useState('date');
  const [isLoading, setIsLoading] = useState(true);
  let start = new Date();
  let end = new Date();
  start.setDate(start.getDate() - 6);
  end.setDate(end.getDate() + 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: start,
    endDate: end,
    key: 'selection',
  });
  const [processedData, setProcessedData] = useState();
  const getEventData = useCallback(async () => {
    setIsLoading(true);
    const {startDate, endDate} = selectionRange;
    const get = async (organization, params) => {
      try {
        return await Api.Instance.current().get(
          `/orgs/${organization}/events`,
          {params},
        );
      } catch (err) {
        console.warn(err);
      }
    };
    const response = await get(props.org, {
      limit: 99999,
      range_start: moment(startDate).format('YYYY-MM-DD'),
      range_end: moment(endDate).format('YYYY-MM-DD'),
      group_id: props.groupId,
    });
    const processed = await processRawData(
      props.org,
      response,
      selectionRange,
      aggregator,
    );
    setProcessedData(processed);
    setIsLoading(false);
    // We do not want to track the change of selectionRange.startDate
    // Only when the endDate has changed do we want to call the api
    // I have not found a way to do this without warnings so I am disabling
  }, [aggregator, props.groupId, props.org, selectionRange.endDate]);

  useEffect(() => {
    getEventData();
  }, [getEventData]);

  return (
    <>
      <Stack
        direction={{xs: 'column', sm: 'row'}}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{marginBottom: 3}}>
        <Typography variant="h5" style={styles.heading}>
          Group Activity
        </Typography>

        <Stack
          direction={{xs: 'column', sm: 'row'}}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}>
          <PfModal
            button={{
              outlined: true,
              text: getRawDateRange(
                selectionRange.startDate,
                selectionRange.endDate,
              ),
            }}
            modal={{
              closeOnBlur: true,
              showClose: false,
              closeOnEsc: true,
            }}>
            <DateRangePicker
              ranges={[selectionRange]}
              rangeColors={[Palette.LINK]}
              id={'groupDateRangePicker'}
              onChange={(ranges) => {
                const {startDate, endDate} = ranges.selection;
                const selection = {};
                if (startDate !== selectionRange.startDate) {
                  selection.startDate = startDate;
                } else if (startDate !== endDate) {
                  selection.endDate = endDate;
                  EventEmitter.dispatch('closeModal');
                }
                setSelectionRange({...selectionRange, ...selection});
              }}
            />
          </PfModal>
          <span style={styles.viewBy}>View by</span>
          <Select
            value={aggregator}
            onChange={(event) => {
              setAggregator(event.target.value);
            }}
            items={aggregatingList.map((agg) => ({
              value: agg.key,
              label: agg.name,
            }))}
            canUnselect={false}
          />
        </Stack>
      </Stack>

      {isLoading ? (
        <LoadingIndicator />
      ) : !processedData?.charts?.engagement ? (
        <Alert style={styles.notificationNoData}>
          NO DATA FOUND FOR THIS PERIOD
        </Alert>
      ) : (
        <MembersOverview
          aggregator={aggregator}
          checkinData={processedData.checkinData}
          activityData={processedData.charts.activity}
          habitData={[]}
          badgeData={processedData.charts.badge}
          appnavigationData={processedData.charts.appnavigationData}
          engagementData={processedData.charts.engagement}
          memberNotifications={props.memberNotifications}
          start={selectionRange.startDate}
          end={selectionRange.endDate}
          rawEvents={processedData.rawEventData}
        />
      )}
    </>
  );
};

const styles = {
  heading: {
    color: Palette.GREY_4,
  },
  viewBy: {
    fontWeight: 'bold',
    color: Palette.GREY_4,
  },
  notificationNoData: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
};
export default Activity;
